import React from 'react';
import { Box, Heading } from '@chakra-ui/react';
import { NewKBLeadProvider } from './context/NewKBLeadContext';
import NewKBBoard from './components/NewKBBoard';

const NewKanbanBoard = () => {
  return (
    <NewKBLeadProvider>
      <Box width="100%" height="100%" p={0}>
        <Box width="100%" overflowX="auto">
          <NewKBBoard />
        </Box>
      </Box>
    </NewKBLeadProvider>
  );
};

export default NewKanbanBoard;
